<template>
    <div
        class="alert"
        :class="`alert-${type}`"
        role="alert"
        v-if="list.length > 0 || message.length > 0"
    >
        <p v-for="(item, index) in list" :key="index">
            {{ item }}
        </p>
        <p v-if="message.length > 0">
            {{ message }}
        </p>
    </div>
</template>

<script>
export default {
    name: 'Alert',
    props: {
        type: {
            type: String,
            default: 'info'
        },
        list: {
            type: Array,
            default: () => []
        },
        message: {
            type: String,
            default: ''
        }
    },

}
</script>

<style>

</style>